import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        const u = res.data.user;
        setUser(u);
        window.history.replaceState(null, "", window.location.pathname);
        if (u.role === "super_admin" || u.role === "staff") navigate("/admin", { state: { user: u } });
        else navigate("/portal", { state: { user: u } });
      } catch (e) {
        navigate("/login?error=auth");
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAF9]">
      <div className="text-center animate-fade-up">
        <Logo size="lg" />
        <p className="mt-6 text-[#4A635A] text-sm">Signing you in securely…</p>
      </div>
    </div>
  );
}
